import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  user = {
    userName: '',
  };
  errMessage = "";
  successMessage = "";
  forgotForm: FormGroup;
  was_successfull = false;


  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private http: HttpClient,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit() {


    this.forgotForm = this.fb.group({
      userName: ['', [
 
        Validators.required,
        Validators.email, 

      ]]
    })
  }

  get userName() { return this.forgotForm.get('userName') };
  forgotPassword() {
    var elm = document.getElementById('forgot-form');
    elm.classList.add("reg-form-success");
    document.getElementById('loader').style.display="block";

    var userName = this.forgotForm.get('userName').value;

      var userData = {
        userName: userName,
      }

      
      this.http.post(environment.FORGOT_PASSWORD_END_POINT, userData, this.httpOptions).subscribe(
        (res: any) => {
          console.log("Login success");
          if (res.status == 200) {
            document.getElementById('loader').style.display="none";
            this.errMessage = "";
            this.successMessage = "";
            this.was_successfull = true;
            this.successMessage = "Linkki lähetetty sähköpostiisi onnistuneesti!";
            elm.classList.remove("reg-form-success");
            this.forgotForm.get('userName').setValue('');

            var toLoginBtn = document.getElementById('toLogin');
            
          } else {
            this.errMessage = "";
            this.successMessage = "";
            this.errMessage = res.message;

          }
          
        }, (err: any) => {

          console.log("Error while login :: ", err);
        }
      )

    }

}
